import React, { useEffect, useState } from 'react';
import { injectIntl } from "react-intl";
import ConfirmDialog from "../ConfirmDialog/ConfirmDialog";
import { useHistory } from 'react-router-dom';
import './style.scss';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../store/referenceLabs/actions';
import { arabicConvertor } from '../../utils/Shared';
import PhoneInputComponent from '../Controls/PhoneInput/PhoneInput';

function RefForm({ intl: { messages }, reference }) {
    const history = useHistory();
    const dispatch = useDispatch();
    const { countries } = useSelector((state) => state?.referenceLabs);
    const [cancelConfirmation, setCancelConfirmation] = useState(false);
    const [feedback, setFeedback] = useState('');
    const [countriesList, setCountriesList] = useState([]);
    const lang = localStorage.getItem('lang');

    useEffect(() => {
        dispatch(actions.getCountriesRequest());
    }, [dispatch]);

    useEffect(() => {
        if (countries) {
            setCountriesList(countries);
        }
    }, [countries]);

    const [formData, setFormData] = useState({
        id: null,
        code: '',
        name: {
            en: '',
            ar: ''
        },
        country_id: 0,
        city_name: '',
        map_link: '',
        user_name: {
            en: '',
            ar: ''
        },
        user_position: '',
        phone_number: '',
        email: '',
    });

    const clear = () => {
        setFormData({
            id: null,
            code: '',
            name: {
                en: '',
                ar: ''
            },
            country_id: 0,
            city_name: '',
            map_link: '',
            user_name: {
                en: '',
                ar: ''
            },
            user_position: '',
            phone_number: '',
            email: '',
        });
        document.getElementById('code').style.borderColor = '#eee';
        document.getElementById('enname').style.borderColor = '#eee';
        document.getElementById('arname').style.borderColor = '#eee';
        document.getElementById('country').style.borderColor = '#eee';
        document.getElementById('city').style.borderColor = '#eee';
        document.getElementById('googlemap').style.borderColor = '#eee';
        document.getElementById('user_enname').style.borderColor = '#eee';
        document.getElementById('user_arname').style.borderColor = '#eee';
        document.getElementById('position').style.borderColor = '#eee';
        document.getElementById('email').style.borderColor = '#eee';
        document.getElementById('phone').style.borderColor = '#eee';
    }

    useEffect(() => {
        if (reference) {
            setFormData({
                id: reference.id,
                code: reference.code,
                name: {
                    en: reference.name?.en,
                    ar: reference.name?.ar
                },
                country_id: reference.country_id,
                city_name: reference.city_name,
                map_link: reference.map_link,
                user_name: {
                    en: reference.user_name?.en,
                    ar: reference.user_name?.ar
                },
                user_position: reference.user_position,
                phone_number: reference.phone_number?.replace(/\+/g, ""),
                email: reference.email,
            });
        }
    }, [reference]);

    const validation = () => {
        let isValid = true;
        /* if (formData.map_link === '') {
            document.getElementById('googlemap').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.referenceLabs.form.blood_error);
        }
        if (formData.city_name === '') {
            document.getElementById('city').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.referenceLabs.form.blood_error);
        }
        if (formData.country_id === 0) {
            document.getElementById('country').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.referenceLabs.form.ref_lab_error);
        } */
        if (formData.name.en === '') {
            document.getElementById('enname').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.referenceLabs.form.en_name_invalid);
        }
        /* if (formData.name.ar === '') {
            document.getElementById('arname').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.referenceLabs.form.ar_name_invalid);
        }
        if (formData.code === '') {
            document.getElementById('code').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.referenceLabs.form.google_placeholder);
        } */

        return isValid;
    }

    const userValidation = () => {
         // User Validation
        let isValid = true;
        // eslint-disable-next-line no-useless-escape
        const phoneRegex = /^[+]*[(]{0,1}[0-9]{1,3}[)]{0,1}[-\s\./0-9]*$/g;
        // eslint-disable-next-line no-useless-escape
        const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

        if (formData.phone_number !== '' && !phoneRegex.test(formData.phone_number)) {
            document.getElementById('phone').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.users.form.phone_invalid);
        }
        if (formData.email !== '' && !emailRegex.test(formData.email)) {
            document.getElementById('email').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.users.form.email_invalid);
        }
        /* if (formData.role_id === '') {
            document.getElementById('position').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.users.form.position_invalid);
        }
        if (formData.name.ar === '') {
            document.getElementById('user_arname').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.users.form.ar_name_invalid);
        }
        if (formData.name.en === '') {
            document.getElementById('user_enname').style.borderColor = '#d58c8c';
            isValid = false;
            setFeedback(messages.users.form.en_name_invalid);
        } */
        return isValid;
    }

    // Save Function
    const handleSave = (e) => {
        e.preventDefault()
        if (validation() && userValidation()) {
            setFeedback('');
            if (reference) {
                dispatch(actions.editReferenceLabRequest({...formData, phone_number: `+${formData.phone_number}`}, history));
            } else {
                dispatch(actions.addReferenceLabRequest({...formData, phone_number: `+${formData.phone_number}`}, history));
            }
        }
    }

    // Cancel Function
    const handleCancel = (e) => {
        e.preventDefault();
        if (reference) {
            if (formData.code === reference.code && formData.name.en === reference.name.en && formData.name.ar === reference.name.ar && formData.city_name === reference.city_name && formData.country_id === reference.country_id && formData.map_link === reference.map_link) {
                history.push(`/reference-labs`);
            } else {
                setCancelConfirmation(true);
            }
        } else {
            if (formData.code === '' && formData.name.en === '' && formData.name.ar === '' && formData.city_name === '' && formData.country_id === 0 && formData.map_link === '') {
                history.push(`/reference-labs`);
            } else {
                setCancelConfirmation(true);
            }
        }
    }

    //console.log(reference);

    return (
        <div className='userform_container'>
            <form>
                <h3>{messages.referenceLabs.form.title}</h3>
                <div className="row">
                    <div className="col-md-4">
                        <label htmlFor="code">{messages.referenceLabs.form.code}</label>
                        <input type="text" name="code" id="code" autoFocus={true}
                                placeholder={messages.referenceLabs.form.code_placeholder}
                                value={formData.code}
                                onChange={e => {
                                    //const re = /^[A-Za-z]+$/;
                                    //if (e.target.value === "" || re.test(e.target.value)) {
                                        document.getElementById('code').style.borderColor = '#eee';
                                        setFeedback('');
                                        setFormData({ ...formData, code: e.target.value })
                                    //}
                                    }} />
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="arname">{messages.referenceLabs.form.ar_name}</label>
                        <input type="text" name="arname" id="arname" 
                                placeholder={messages.referenceLabs.form.ar_name_placeholder}
                                value={formData.name.ar}
                                onChange={e => {
                                    document.getElementById('arname').style.borderColor = '#eee';
                                    setFeedback('');
                                    setFormData({ ...formData, name: { ...formData.name, ar: arabicConvertor(e.target.value) } })
                                    }} />
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="enname" className='required'>{messages.referenceLabs.form.en_name}</label>
                        <input type="text" name="enname" id="enname"
                                placeholder={messages.referenceLabs.form.en_name_placeholder}
                                value={formData.name.en} 
                                onChange={e => {
                                    document.getElementById('enname').style.borderColor = '#eee';
                                    setFeedback('');
                                    setFormData({ ...formData, name: { ...formData.name, en: e.target.value } })
                                    }} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <label htmlFor="country">{messages.referenceLabs.form.countries}</label>
                        <select name="country" id="country"
                                value={formData.country_id}
                                onChange={e => {
                                    document.getElementById('country').style.borderColor = '#eee';
                                    setFeedback('');
                                    setFormData({ ...formData, country_id: e.target.value })
                                    }}>
                            <option value={0}>{messages.referenceLabs.form.countries_placeholder}</option>
                            {countriesList?.map(country => <option key={country.id} value={country.id}>{country.name}</option>)}
                        </select>
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="city">{messages.referenceLabs.form.city}</label>
                        <input type="city" name="city" id="city"
                            placeholder={messages.referenceLabs.form.city_placeholder}
                            value={formData.city_name}
                            onChange={e => {
                                document.getElementById('city').style.borderColor = '#eee';
                                setFeedback('');
                                setFormData({ ...formData, city_name: e.target.value })
                                }} />
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="googlemap">{messages.referenceLabs.form.google}</label>
                        <input type="googlemap" name="googlemap" id="googlemap"
                            placeholder={messages.referenceLabs.form.google_placeholder}
                            value={formData.map_link}
                            onChange={e => {
                                document.getElementById('googlemap').style.borderColor = '#eee';
                                setFeedback('');
                                setFormData({ ...formData, map_link: e.target.value })
                                }} />
                    </div>
                </div>
                <h3 className='mt-4'>{messages.referenceLabs.form.user_title}</h3>
                <div className="row">
                    <div className="col-md-4">
                        <label htmlFor="user_arname">{messages.users.form.ar_name}</label>
                        <input type="text" name="user_arname" id="user_arname"
                                placeholder={messages.users.form.ar_name_placeholder}
                                value={formData.user_name.ar}
                                onChange={e => {
                                    document.getElementById('user_arname').style.borderColor = '#eee';
                                    setFeedback('');
                                    setFormData({ ...formData, user_name: { ...formData.user_name, ar: arabicConvertor(e.target.value) } })
                                    }} />
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="user_enname">{messages.users.form.en_name}</label>
                        <input type="text" name="user_enname" id="user_enname"
                                placeholder={messages.users.form.en_name_placeholder}
                                value={formData.user_name.en} 
                                onChange={e => {
                                    document.getElementById('user_enname').style.borderColor = '#eee';
                                    setFeedback('');
                                    setFormData({ ...formData, user_name: { ...formData.user_name, en: e.target.value } })
                                    }} />
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="position">{messages.users.form.position}</label>
                        <input type="text" name="position" id="position"
                                placeholder={messages.referenceLabs.form.position_placeholder}
                                value={formData.user_position}
                                onChange={e => {
                                    document.getElementById('position').style.borderColor = '#eee';
                                    setFeedback('');
                                    setFormData({ ...formData, user_position: e.target.value })
                        }} />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4">
                        <label htmlFor="email">{messages.users.form.email}</label>
                        <input type="email" name="email" id="email"
                            placeholder={messages.users.form.email_placeholder}
                            value={formData.email}
                            onChange={e => {
                                document.getElementById('email').style.borderColor = '#eee';
                                setFeedback('');
                                setFormData({ ...formData, email: e.target.value })
                                }} />
                    </div>
                    <div className="col-md-4">
                        <label htmlFor="phone">{messages.users.form.mobile}</label>
                            <PhoneInputComponent name="phone" id="phone" lang={lang}
                                myplaceholder={messages.users.form.mobile_placeholder}
                                myvalue={formData.phone_number}
                                onValueChange={(val) => {
                                    document.getElementById('phone').style.borderColor = '#eee';
                                    setFeedback('');
                                    setFormData({ ...formData, phone_number: val })
                                    }}
                                />
                    </div>
                </div>
                <div className='form-footer'>
                    <p>&nbsp;{feedback}</p>
                    <div className="actions">
                        <button type="button" className="myBtn" onClick={(e) => handleSave(e)}>{messages.users.form.btn_save}</button>
                        <button type="button" className="myBtn cancel" onClick={e => {
                            handleCancel(e);
                        }}>{messages.users.form.btn_cancel}</button>
                    </div>
                </div>
            </form>
            <ConfirmDialog show={cancelConfirmation} 
                     onCancel={() => setCancelConfirmation(false)}
                     onConfirm={() => {
                        setCancelConfirmation(false);
                        clear();
                        history.push('/reference-labs');
                     }}
                     icon={null}
                     content={messages.warningMsgs.warning_close_window}
                     cancelBtn={messages.warningMsgs.cancel}
                     confirmBtn={messages.warningMsgs.confirm} />
        </div>
    );
}

export default injectIntl(RefForm);